




























































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../../lib/util";
import AbpBase from "../../../lib/abpbase";
import CustomerType from "@/store/entities/customer-types/customer-type";
import DateTimeMixin from "@/components/mixin/date-time-mixin";
import { mixins } from "vue-class-component";

@Component
export default class CreateCustomer extends mixins(DateTimeMixin, AbpBase) {
  @Prop({ type: Boolean, default: false }) value: boolean;
  customerType: CustomerType = new CustomerType();
  pricingTerms = [];
  spinShow: boolean = false;
  code: string = "";
  isClient() {
    return this.$store.state.session.client != null;
  }
  async getCustomerTypeInfo() {
    this.code = this.$root.$router.currentRoute.params.code;
    await this.$store
      .dispatch({
        type: "customerType/get",
        data: {
          id: this.code,
        },
      })
      .then((res) => {
        this.customerType = res;
      });
  }
  async getPricingTerms() {
    await this.$store
      .dispatch({
        type: "productPricing/getPricingTerms",
        data: { hasAllItem: false },
      })
      .then((result) => {
        this.pricingTerms = result;
      });
  }
  async save() {
    this.$Modal.confirm({
      title: this.L("Tips"),
      content: this.L("Confirm.UpdateCustomerType"),
      okText: this.L("Yes"),
      cancelText: this.L("No"),
      onOk: async () => {
        this.spinShow = true;
        try {
          await this.$store
            .dispatch({
              type: "customerType/update",
              data: {
                id: this.customerType.id,
                name: this.customerType.name,
                pricingTermCode: this.customerType.pricingTermCode,
              },
            })
            .then((result) => {
              Util.showSuccessMsg(this, "Success.UpdateCustomerType");
              this.reset();
              this.onGoBack();
            });
          this.spinShow = false;
        } catch (error) {
          this.spinShow = false;
        }
      },
    });
  }
  onGoBack() {
    this.$root.$router.push({ name: "customertype" });
  }

  reset() {
    this.spinShow = false;
    this.customerType = new CustomerType();
    this.pricingTerms = [];
  }

  async created() {
    this.spinShow = true;
    try {
      await this.getPricingTerms();
      await this.getCustomerTypeInfo();
      this.spinShow = false;
    } catch (error) {
      this.spinShow = false;
    }
  }
}
